export default __webpack_public_path__ + "static/media/excelicon.cd36a185.svg";